import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { selectCondoMgmtComboBoxOptions } from '@redux/selectors/FormSelector';

const CondoManagementForm = ({ setSubdivisionSelected }) => {
  const [county, setCounty] = useState(null);
  const [city, setCity] = useState(null);
  const [subdivision, setSubdivision] = useState(null);

  const comboIsLoading = useSelector(state => state.formGeneration.comboIsLoading); // combo loading status
  const countyComboValues = useSelector(state => selectCondoMgmtComboBoxOptions(state, 'Lookup_Property_Listing_CountyOrParish'));
  const cityComboValues = useSelector(state => selectCondoMgmtComboBoxOptions(state, 'Lookup_Property_Listing_City'));
  const subdivisionComboValues = useSelector(state => selectCondoMgmtComboBoxOptions(state, 'Lookup_Property_Listing_SubdivisionName'));

  const handleCountyChange = value => setCounty(value);
  const handleCityChange = value => setCity(value);

  const handleSubdivChange = value => {
    setSubdivision(value);
    setSubdivisionSelected(value);
  };

  // Determine the options to display for city based on parent childing rules from County
  const cityOptions = useMemo(() => {
    if (county) {
      // parents is ALWAYS a one-level array since it's already filtered to the city-level;
      return cityComboValues.filter(cityValue => cityValue?.parents?.[0]?.ParentCodes?.[0] === county.value);
    }
    return [];
  }, [county]);

  // Determines the options to display for subdivisions based on parent childing rules from City
  const subdivOptions = useMemo(() => {
    if (city) {
      // parents is ALWAYS a one-level array since it's already filtered to the subdivision-level;
      return subdivisionComboValues.filter(subdiv => subdiv?.parents?.[0]?.ParentCodes?.[0] === city.value);
    }
    return [];
  }, [city]);

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="countySelect">County</label>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          FieldName="CountyOrParish"
          id="countySelect"
          isClearable
          isLoading={comboIsLoading}
          onChange={handleCountyChange}
          options={countyComboValues}
          placeholder="Choose one"
        />
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor="citySelect">City</label>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          FieldName="City"
          id="citySelect"
          isDisabled={!county}
          isClearable
          onChange={handleCityChange}
          options={cityOptions}
          placeholder="Choose one"
        />
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor="subdivisionSelect">Subdivision Name</label>
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          FieldName="SubdivisionName"
          id="subdivisionSelect"
          isDisabled={!city || !county}
          isClearable
          onChange={handleSubdivChange}
          options={subdivOptions}
          placeholder="Choose one"
          value={subdivision}
        />
      </div>
    </>
  );
};

CondoManagementForm.propTypes = {
  setSubdivisionSelected: PropTypes.func,
};

export default CondoManagementForm;
